import { tsInitVue } from '../js-utils'
import SurveyQuestionManager from '../../js/vue-components/survey-question-manager.vue'
import SurveyReportSettingsManager from '../../js/vue-components/survey-report-settings-manager.vue'
import type {SurveyReportData} from "../../js/vue-components/survey-types"

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.admin-surveys .surveys-form')) {
    const questionManagerEl = document.querySelector('[data-is="SurveyQuestionManager"]')
    if (questionManagerEl instanceof HTMLElement) {
      window.surveyQuestionManager = tsInitVue(SurveyQuestionManager, questionManagerEl, {
        questionDataFieldRef: questionManagerEl.dataset.questionDataFieldRef,
        allowSections: questionManagerEl.dataset.allowSections == 'true'
      })
    }
  }

  if (document.querySelector('body.admin-surveys')) {
    const reportSettingsEl = document.querySelector('[data-is="SurveyReportSettingsManager"]')
    if (reportSettingsEl instanceof HTMLElement) {
      window.surveyReportSettingsManager = tsInitVue(SurveyReportSettingsManager, reportSettingsEl, {
        previewUrl: reportSettingsEl.dataset.previewUrl,
        surveyData: window.reportSettings as SurveyReportData | null,
      })
    }
  }
})
